// extracted by mini-css-extract-plugin
export default {"text":"intentions-page_text__qVAp5"};